module.exports = __webpack_public_path__ + "img/20240219051934565y07.849beba0.jpg";